import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import DirectoryEditor from "./DirectoryEditor";

const PartyEditor = () => {
  const { partyId } = useParams();
  const [party, setParty] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const isNew = partyId === "new";

  useEffect(() => {
    const fetchParty = async () => {
      if (isNew) {
        setParty({
          _id: crypto.randomUUID(),
  name: "",
  type: "",
  roleCode: "",
  partyIdentities: [],
  address: {
    type: "",
    numberAndStreet: "",
    subentityCode: "",
    cityName: "",
    postalCode: "",
    countryCode: ""
  },
  contact: {
    description: "",
    roleCode: "",
    personName: "",
    telephone: "",
    fax: "",
    email: ""
  }
});
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://directory.poc.mrc.ai/api/parties/${partyId}`);
          const data = await res.json();
          setParty(data);
        } catch (error) {
          console.error("Error loading party", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchParty();
  }, [partyId, isNew]);

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <DirectoryEditor party={party} onClose={handleClose} isNew={isNew} />;
};

export default PartyEditor;
